export const addTagToSelection = (createdTagDoc, value, onChange) => {
  const newTag = {
    _id: createdTagDoc._id,
    display: createdTagDoc?.main?.title || createdTagDoc.display,
    tagId: createdTagDoc.tagId,
  };

  let preVal = value['tags'];
  if (preVal) {
    preVal = { ...preVal, data: [...(preVal.data || []), newTag] };
  } else {
    preVal = { collectionId: 'tags', data: [newTag] };
  }
  onChange('tags', preVal);
};

export const createTagWithAssociations = (mutateFn, { display, subThemeId } = {}) => {
  return new Promise((resolve, reject) => {
    // DEFENSIVE CHECK: Don't allow creating tags with temp subTheme IDs
    if (subThemeId && typeof subThemeId === 'string' && subThemeId.includes('temp-')) {
      reject(new Error('Cannot create tag association with unsaved subTheme. Please wait for the subTheme to be saved first.'));
      return;
    }

    const customFields = {};
    if (subThemeId) {
      customFields.tags = {
        subThemes: {
          collectionId: 'subThemes',
          data: [{ _id: subThemeId }]
        }
      };
    }
    // No meta.taxonomyRole stamped on tags — readers always use the parent
    // subTheme's role as authoritative. Stamping tags would drift on
    // taxonomyRole flips and add no value.

    mutateFn(
      {
        type: 'tags',
        display,
        customFields
      },
      {
        onSuccess: (res) => resolve(res?.data),
        onError: (err) => reject(err),
      }
    );
  });
};


